import React from "react";
import {toast} from 'react-toastify';

const defaultOptions = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
};

function success(title, message) {
    // guard: ensure toast and the success method exist
    if (!toast || typeof toast.success !== 'function') {
        console.warn('toast.success is not available - falling back to alert');
        if (typeof window !== 'undefined') window.alert((title ? title + '\n' : '') + (message || ''));
        return null;
    }

    return toast.success(<div>
        <h3 className={"h2-title"}>{title}</h3>
        <div className={"toast-msg"}><i className="toast-icon fas fa-check-circle fa-2x"/>{message}</div>
    </div>, defaultOptions)
}

function info(title, message) {
    if (!toast || typeof toast.info !== 'function') {
        console.warn('toast.info is not available - falling back to alert');
        if (typeof window !== 'undefined') window.alert((title ? title + '\n' : '') + (message || ''));
        return null;
    }

    return toast.info(<div>
        <h3 className={"h2-title"}>{title}</h3>
        <div className={"toast-msg"}><i className="justify-content-center toast-icon fas fa-info-circle fa-2x"/>{message}</div>
    </div>, defaultOptions);
}

function warning(title, message) {
    if (!toast || typeof toast.warning !== 'function') {
        console.warn('toast.warning is not available - falling back to alert');
        if (typeof window !== 'undefined') window.alert((title ? title + '\n' : '') + (message || ''));
        return null;
    }

    return toast.warning(<div className={"justify-content-center"}>
        <h3 className={"h2-title"}>{title}</h3>
        <div className={"toast-msg"}><i className="toast-icon fas fa-exclamation-triangle fa-2x"/>{message}</div>
    </div>, defaultOptions)
}

function error(title, message) {
    if (!toast || typeof toast.error !== 'function') {
        console.warn('toast.error is not available - falling back to alert');
        if (typeof window !== 'undefined') window.alert((title ? title + '\n' : '') + (message || ''));
        return null;
    }

    return toast.error(<div>
        <h3 className={"h2-title"}>{title}</h3>
        <div className={"toast-msg"}><i className="toast-icon fas fa-times fa-2x"/>{message}</div>
    </div>, defaultOptions)
}

export const showToastCustom = (typeAction = "success", message = null, title = null) => {
    const key = (typeAction || 'success').toString().toLowerCase();
    const actions = { success, info, warning, error };
    const fn = actions[key];
    if (typeof fn === 'function') return fn(title, message);
    console.warn('Unknown toast type: ' + key + ' - defaulting to success');
    return success(title, message);
}

export const showToast = (typeAction, message = null, status) => {
    let title = '';
    if (status) {
        if (typeAction === "SAVE") {
            title = 'Registro guardado exitosamente';
        } else if (typeAction === "UPDATE") {
            title = 'Registro actualizado exitosamente';
        } else {
            title = 'Registro eliminado exitosamente';
        }

    // use safe wrapper to avoid direct access to toast (may be undefined in some contexts)
    return success(title, message);
    } else {
        title = 'Error';
    return error(title, message);
    }
}

